import styled from "@mui/material/styles/styled";
import { Box } from "@mui/material";
import { SIDEBAR_COLLAPSED_WIDTH } from "../Sidebar/Sydebar.styled";

export const MainLayoutContainer = styled(Box)(({ theme }) => ({
  minHeight: "100vh",
  display: "flex",
  flexDirection: "column",
  backgroundColor: theme.palette.background.default,
}));

export const MainContentArea = styled(Box)(({ theme }) => ({
  flex: 1,
  marginLeft: `${SIDEBAR_COLLAPSED_WIDTH}px`,
  padding: theme.spacing(3),
  backgroundColor: theme.palette.background.default,
  minHeight: "calc(100vh - 64px)",
  height: "100vh",
  overflow: "auto",
}));
